import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "App-Page-Header App-Opportunity-T" }
const _hoisted_2 = { class: "App-Opp-Top" }
const _hoisted_3 = {
  style: {"line-height":"20px","margin-bottom":"4px","display":"flex","width":"100","align-items":"center","justify-content":"space-between"},
  "w-100": "",
  size: 12
}
const _hoisted_4 = { "m-tb-0": "" }
const _hoisted_5 = { "mute-secondary": "" }
const _hoisted_6 = {
  key: 0,
  "m-t-1": ""
}
const _hoisted_7 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_avatar = _resolveComponent("el-avatar")!
  const _component_app_over_avatars = _resolveComponent("app-over-avatars")!
  const _component_el_space = _resolveComponent("el-space")!
  const _component_app_ent_standing = _resolveComponent("app-ent-standing")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_space, {
        "w-100": "",
        alignment: "center",
        size: 12
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", null, [
            _createVNode(_component_app_over_avatars, { size: 56 }, {
              one: _withCtx(() => [
                _createVNode(_component_el_avatar, {
                  src: _ctx.opportunity.createdBy.avatar,
                  icon: "el-icon-user-solid",
                  size: 51
                }, null, 8, ["src"])
              ]),
              two: _withCtx(() => [
                _createVNode(_component_el_avatar, {
                  src: _ctx.business.avatar,
                  icon: "el-icon-office-building",
                  size: 51
                }, null, 8, ["src"])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", null, [
              _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.business.name), 1),
              _createElementVNode("span", null, _toDisplayString(_ctx.business.industry) + " Industry, " + _toDisplayString(_ctx.business.stage) + " Stage ", 1)
            ]),
            _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$filters.capitalize(_ctx.$moment(_ctx.opportunity.createdAt).fromNow())), 1)
          ])
        ]),
        _: 1
      }),
      _createElementVNode("div", null, [
        (_ctx.viewedBy === 'founder')
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createVNode(_component_app_ent_standing, {
                labelSelf: `${_ctx.$filters.capitalize(
              _ctx.$filters.slice(_ctx.business.name, 30)
            )}`,
                standingSelf: _ctx.business.standing,
                size: "medium"
              }, null, 8, ["labelSelf", "standingSelf"])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createVNode(_component_app_ent_standing, {
                labelSelf: `${_ctx.$filters.capitalize(_ctx.user.firstName)}`,
                labelOther: `${_ctx.$filters.capitalize(_ctx.business.name)}`,
                standingSelf: _ctx.user.standing,
                standingOther: _ctx.business.standing,
                size: "medium"
              }, null, 8, ["labelSelf", "labelOther", "standingSelf", "standingOther"])
            ]))
      ])
    ])
  ]))
}